import share from './share.vue'

let Share = {}

// 只有定义了 install 方法，才能使用 Vue.use() 进行引用
Share.install = function (Vue) {
  // 添加实例方法 - 扩展方法
  const ShareController = Vue.extend(share)
  let instance = new ShareController().$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$share = function (o) {
    instance.favorateShow = ''
    instance.favorateIcon = ''
    instance.removeIcon = false
    instance.reverseIcon = false
    instance.reportIcon = false
    instance.item = {}
    instance.comment = []
    instance.type = 'article'
    if (o.favorateShow) {
      instance.favorateShow = o.favorateShow
    }
    if (o.favorateIcon) {
      instance.favorateIcon = o.favorateIcon
    }
    if (o.removeIcon) {
      instance.removeIcon = o.removeIcon
    }
    if (o.reverseIcon) {
      instance.reverseIcon = o.reverseIcon
    }
    if (o.reportIcon) {
      instance.reportIcon = o.reportIcon
    }
    if (o.item) {
      instance.item = o.item
    }
    if (o.comment) {
      instance.comment = o.comment
    }
    if (o.type) {
      instance.type = o.type
    }
    if (o.shareMessage) {
      instance.shareMessage = o.shareMessage
    }
    instance.shareBox = true
    instance.shareShow = true
  }

  Vue.prototype.$share.close = function () {
    instance.cancelshareBox(false)
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Share)
}

export default Share



// WEBPACK FOOTER //
// ./src/components/base/share/index.js